import axios from 'axios';

export class LocationsRepo {
    protected client; // Define the axios instance

    constructor(protected config: any) {
        this.client = axios.create({
            baseURL: config.public.locationsEndpoint,
        });
    }

    // Method to get data from a specific endpoint
    async get(endpoint: string = '') {
        return await this.client.get(endpoint);
    }
}
